module.exports = __webpack_public_path__ + "static/img/w10.514cb9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/mobile/w10.jpg
// module id = 6X6c
// module chunks = 1